import React, { useRef } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { BACKEND } from "../config/configEnvs";
import multiMonthPlugin from "@fullcalendar/multimonth";
import { FaCalendar } from "react-icons/fa";
import Tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import DrawerCalendarioTareasAudiovisualesMeets from "../components/calendarioCitas/DrawerCalendarioTareasAudiovisualesMeets.jsx";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen.jsx";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen.jsx";
import { getStartAndEndOfMonth } from "../utils/GetDates.js";



const CalendarioCitas = () => {
  const profile = useSelector((state) => state.auth.user);
  const user = useSelector((state) => state.auth.user);
  const isAdmin = profile.area.toUpperCase() === "ADMINISTRACION"

  const [loading, setLoading] = useState(false)
  
  const toastId = useRef(null)

  const [isMobile, setIsMobile] = useState(false);

  const [totalEvents, setTotalEvents] = useState(0)

  const [eventsList, setEventsList] = useState([])
  //console.log(eventsList)

  const [brandName, setBrandName] = useState("")
  const [workers, setWorkers] = useState([])
  const [selectedResponsable, setSelectedResponsable] = useState("")

  const [openDrawer, setOpenDrawer] = useState(false);
  const [currentCot, setCurrentCot] = useState(null);
  const [currentEvent, setCurrentEvent] = useState(null)

  const [isMeeting, setIsMeeting] = useState(true)
  const [isVisit, setIsVisit] = useState(true)

  const {start, end} = getStartAndEndOfMonth();

  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")

  const [selectedStatus, setSelectedStatus] = useState("Finalizado")

  const CountEvents = (allEvents) => {
    // Solo contar si las fechas están definidas
    if (!startDate || !endDate) return;
    
    const filteredEvents = allEvents.filter(event => {
      const eventDate = event?.deliverDate ? event.deliverDate : event?.limitDate;
      return eventDate >= startDate && eventDate <= endDate;
    });
    
    setTotalEvents(filteredEvents.length);
  }

  const HandleSearch = () => {
    getEvents();
  }
  
  useEffect(() => {
    if (brandName === "") {
      getEvents();
    }
  }, [brandName])

  const getEvents = async () => {
    try {
      setLoading(true)
      
      let allEvents = [];

      // Solo hacer la petición de visitas si isVisit es true
      if (isVisit) {
        let urlVisits = isAdmin
          ? `${BACKEND}/api/tareasProyectos?where[isVisit][equals]=true&limit=0&depth=5`
          : `${BACKEND}/api/tareasProyectos?where[isVisit][equals]=true&limit=0&where[responsible][equals]=${profile.id}&depth=5`;
          
        if(selectedResponsable && isAdmin) {
          urlVisits = urlVisits + `&where[responsible][equals]=${selectedResponsable}`
        }
        
        if (selectedStatus) {
          urlVisits = urlVisits + `&where[status][equals]=${selectedStatus}`
        }


        const responseVisits = await axios.get(urlVisits);
        allEvents = [...allEvents, ...responseVisits.data.docs];
      }

      // Solo hacer la petición de reuniones si isMeeting es true
      if (isMeeting) {
        let urlMeetings = isAdmin
          ? `${BACKEND}/api/tareasProyectos?where[isMeeting][equals]=true&limit=0&depth=5`
          : `${BACKEND}/api/tareasProyectos?where[isMeeting][equals]=true&&limit=0&where[responsible][equals]=${profile.id}&depth=5`;

        if(selectedResponsable && isAdmin) {
          urlMeetings = urlMeetings + `&where[responsible][equals]=${selectedResponsable}`
        }

        if (selectedStatus) {
          urlMeetings = urlMeetings + `&where[status][equals]=${selectedStatus}`
        }

        const responseMeetings = await axios.get(urlMeetings);
        allEvents = [...allEvents, ...responseMeetings.data.docs];
      }

      setEventsList(allEvents);
      CountEvents(allEvents)

    } catch (error) {
      toast.error("Error al cargar los eventos");
    } finally {
      setLoading(false)
    }
  };

  const selectEventToGetCot = async (idPagoCot) => { // Traer la cotización del evento

    try {
      toastId.current = toast.loading("Cargando cotización...")

      const pagoCotizacionResponse = await axios.get(
        `${BACKEND}/api/pagosCotizaciones/${idPagoCot}`
      );

      if (pagoCotizacionResponse.data.cotizacion) {
        const cotizacionResponse = await axios.get(
          `${BACKEND}/api/cotizaciones/${pagoCotizacionResponse.data.cotizacion.id}`
        );
    
        toast.done((toastId.current));
        setCurrentCot(cotizacionResponse.data);
        setOpenDrawer(true);
      } else {
        toast.done((toastId.current));

        toast.error("No existe cotizacion para este evento")
        return;
      }
    } catch (error) {
      toast.done((toastId.current));
      toast.error("No existe cotizacion para este evento")  }
  };

  const selectEventInfoById = async (idEvent) => {
    try {
      toastId.current = toast.loading("Cargando evento...")

      const taskDetails = await axios.get(`${BACKEND}/api/tareasProyectos/${idEvent}?depth=5`);

      toast.done((toastId.current));
      setCurrentEvent(taskDetails.data);
      setOpenDrawer(true);

    } catch (error) {
      toast.done((toastId.current));

      toast.error("No existe este evento agendado")    }
  }

  const getWorkers = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/getUsersIds/getWorkerUsers`)
      setWorkers(response.data)
    } catch (error) {
      toast.error("Error al cargar los responsables")
    }
  }

  useEffect(() => {
    getEvents();
    getWorkers()
  }, []);

  useEffect(() => {
    getEvents();
  }, [isMeeting, isVisit, selectedStatus, selectedResponsable]);

  // Contar eventos cuando cambien las fechas y haya eventos cargados
  useEffect(() => {
    if (eventsList.length > 0 && startDate && endDate) {
      CountEvents(eventsList);
    }
  }, [startDate, endDate, eventsList]);

  return (
    <div className="flex flex-col h-screen w-full">
      
      {/* Header */}
      <div className="flex flex-row px-4 py-1 w-full bg-gray-100">

        <div className="flex flex-row w-full items-center gap-4 justify-between">
          <div className="flex items-center gap-4 py-6">
              <FaCalendar className="text-zinc-700 text-2xl" />
              <h2 className="text-2xl font-bold text-zinc-700">Calendario de citas</h2>
          </div>
        </div>

        <div className="flex flex-row gap-4 items-center justify-center">
           
           <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
             <span>Responsable:</span>
             <select
               value={selectedResponsable}
               onChange={(e) => setSelectedResponsable(e.target.value)}
               className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
             >
               <option value="">Todos</option>
               {workers.map((worker, i) => (
                 <option key={i} value={worker.id}>{worker.name}</option>
               ))}
             </select>
           </div>
          </div>

      </div>
      
      {/* Filtros */}     
      <div className="flex flex-row bg-gray-100 mt-0.5 py-1 px-4">
        <div className="flex flex-row w-full items-center justify-between overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">

          <div className="flex flex-row items-center gap-8">
            <div
              className="flex flex-row items-center justify-center gap-1"
            >
              <span className="text-xs font-bold truncate">Meet</span>
              <input
                type="checkbox"
                className="rounded-md border-gray-400 hover:cursor-pointer"
                checked={isMeeting}
                onChange={(e) =>
                  setIsMeeting(e.target.checked)
                }
              />
            </div>

            <div
              className="flex flex-row items-center justify-center gap-1"
            >
              <span className="text-xs font-bold truncate">Visita</span>
              <input
                type="checkbox"
                className="rounded-md border-gray-400 hover:cursor-pointer"
                checked={isVisit}
                onChange={(e) =>
                  setIsVisit(e.target.checked)
                }
              />
            </div>

            {/* <div>
              <select
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
                id="underline_select"
                className="text-gray-700 bg-white text-xs border hover:cursor-pointer border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="">Todos</option>
                <option value="Pendiente">Pendiente</option>
                <option value="En proceso">En proceso</option>
                <option value="Finalizado">Finalizado</option>
              </select>
            </div> */}
          </div>

          <div className="text-xs font-bold whitespace-nowrap">
            Total eventos: {totalEvents}
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto px-4">

        <DrawerCalendarioTareasAudiovisualesMeets
          open={openDrawer}
          closeDrawer={()=>setOpenDrawer(false)}
          info={currentEvent}
        />

        {loading ? (
          <LoadingScreen />
        ) : eventsList.length === 0 ? (
          <NoDataScreen />
        ) : (
          <FullCalendar
            events={eventsList
              .filter(event => {
                const eventDate = event?.deliverDate ? event.deliverDate : event?.limitDate;
                return eventDate >= startDate && eventDate <= endDate;
              })
              .map((e, i) => ({
                key: i,
                title: `${e?.task.name 
                  + "  /  " + e.objective?.phase?.service?.servicio?.name
                  + "  /  " + e.objective?.phase?.service?.cotizacion?.cliente?.nombreComercial
                  + "  /  " + e.responsible?.name
                }`,
                start: e?.deliverDate,
                end: e?.deliverDate,
                color: e?.isVisit ? "#007BFF" : "#28A745",
                textColor: "white" ,
                className: "text-xs",
                id: e.id
              }))
            }

            eventOrder={"order,start,-duration,title"}
            datesSet={(e) => {
              const viewStartDate = new Date(e.view.currentStart.getTime() + 5 * 60 * 60 * 1000);
              const viewEndDate = new Date(e.view.currentEnd.getTime() + 5 * 60 * 60 * 1000);
              setStartDate(viewStartDate.toISOString().split('T')[0],)
              setEndDate(viewEndDate.toISOString().split('T')[0], )
            }}
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              interactionPlugin,
              listPlugin,
              multiMonthPlugin,
            ]}
            moreLinkText={"Ver todos"}
            locale={"es"}
            headerToolbar={{
              start: "title",
              center: "multiMonthYear,dayGridMonth",
              end: "prev,next",
            }}
            buttonText={{
              today: "Hoy",
              month: "Mes",
              year: "Año",
              week: "Semana",
              day: "Día",
              listMonth: "Agenda del mes",
              listDay: "Agenda hoy",
              timeGrid: "Semana",
            }}
            views={{
              timeGridFourDay: {
                type: "timeGrid",
                duration: { days: 4 },
                buttonText: "Semana",
              },
              timeGridWeek: {
                duration: { days: isMobile ? 4 : 7 },
                buttonText: "Semana",
              },
            }}
            initialView={isMobile ? "timeGridWeek" : "dayGridMonth"}
            moreLinkHint={true}
            defaultAllDay
            dayMaxEvents={false}
            eventContent={function (arg) {
              let containerEl = document.createElement("div");
              containerEl.classList = `event-container cursor-pointer hover:bg-[#FF9F57]`

              let contentEl = document.createElement("p");
              contentEl.classList = "event-content overflow-hidden";

              if (arg.event.extendedProps.isUrgent) {
                contentEl.innerHTML = "urgent event";
              } else {
                contentEl.innerHTML = `${arg.event.title}`;
              }

              containerEl.appendChild(contentEl);

              // Add click event listener
              containerEl.addEventListener("click", async function (event) {
                // Check if the clicked element matches the desired element
                if (event.target.classList.contains("event-content")) {
                  // Perform asynchronous logic
                  await navigator.clipboard.writeText(arg.event.id);

                  await selectEventInfoById(arg.event.id);
                }
              });

              return { domNodes: [containerEl] };
            }}
            eventDidMount={(info) => {
              Tippy(info.el, {
                content: info.event.title,
                placement: 'top',
                theme: 'dark',
                animation: 'scale'
              });
            }}
            initialEvents={[]}
          />
        )}

      </div>

    </div>
  );
};

export default CalendarioCitas;
